import React from 'react';

import CountryList from 'country-list-with-dial-code-and-flag';

import styled from 'styled-components';
import CustomButton from '../CustomButton/CustomButton';

import { useSelector, useDispatch } from 'react-redux';
import assets from 'assets';
import { useSearchParams } from 'react-router-dom';

const CountryBanner = () => {
  const dispatch = useDispatch();
  const { country, countryDiscount } = useSelector(state => state.location);

  const [, setParams] = useSearchParams(window.location.search);

  const handleCloseBanner = () => {
    dispatch.location.closeBanner();
    setParams();
  };

  const handleDiscount = () => {
    if (countryDiscount) {
      dispatch.utils.setSubscriptionModal(true);
      dispatch.utils.setOpenMobileRightMenu(false);
    }
  };

  return (
    <Container>
      <div className='flex-row'>
        <div className='flag'>
          <h1 style={{ lineHeight: '30px', paddingTop: '5px' }}>
            {CountryList.findOneByCountryCode(country.country).flag}
          </h1>
        </div>
        <p className='font-size-16'>
          We are offering 50% off any plan in your country.
        </p>
      </div>
      <CustomButton
        label='Claim your discount now!'
        className='btn'
        onClick={handleDiscount}
      />
      <div className='close-btn' role='button' onClick={handleCloseBanner}>
        <img src={assets.close} alt='' />
      </div>
    </Container>
  );
};

export default CountryBanner;

const Container = styled.div`
  position: relative;
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.colors.darkgrey};
  border: 1px solid ${({ theme }) => theme.colors.border};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
  color: ${({ theme }) => theme.colors.primary};
  border-radius: 12px;
  margin: 10px;
  margin-bottom: 0px;
  height: 60px;

  & p {
    margin: 0px;
  }

  & .flex-row {
    gap: 20px;
    justify-content: center;
  }

  & .flag {
    padding-inline: 15px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      width: 1px;
      height: 80%;
      right: 0px;
      top: 50%;
      transform: translateY(-50%);
      background-color: ${({ theme }) => theme.colors.primary + '66'};
    }
  }

  & .btn {
    height: 42px;
    font-size: 15px;
  }

  & .close-btn {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    height: 24px;
    width: 24px;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    opacity: 0.6;
    overflow: hidden;
    cursor: pointer;

    & img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  @media only screen and (max-width: 900px) {
    flex-direction: column;
    gap: 10px;
    height: auto;
    padding-inline: 35px;
    margin-bottom: 10px;
    & .close-btn {
      top: 25px;
      right: 15px;
    }

    & .btn {
      width: 100%;
    }
  }
`;
